import React, { useState, useEffect } from "react";
import { displayFormatDate, toggleMenu } from "../../utils/helpers";
import PageTitle from "../../components/PageTitle";
import SortableTable from "../../components/SortableTable";
import Pagination from "../../components/Pagination";
import axios from "axios";
import Cookies from "js-cookie";
import { TailSpin } from "react-loader-spinner";
import NoRecordsAvailable from "../../components/NoRecordsAvailable";
import { API_GET_RAISED_CONCERNS_BY_EMPLOYEE } from "../../config/Endpoints";
import Badge from "../../components/Badge";
import { Link } from "react-router-dom";
import RaiseConcern from "../Dashboard/RaiseConcern";

const MyConcerns = ({ title, description }) => {
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = Cookies.get("accessToken");

  const columns = [
    { key: "concernRequest", label: "Raised Concern", sortable: true },
    {
      key: "concernDate",
      label: "Concern Date",
      sortable: true,
      compare: (a, b) =>
        new Date(a._original.concernDate) - new Date(b._original.concernDate),
    },
    { key: "punchIn", label: "Punch In", sortable: true },
    { key: "punchOut", label: "Punch Out", sortable: true },
    { key: "totalHours", label: "Total Hours", sortable: true },
    {
      key: "status",
      label: "Status",
      sortable: true,
      render: (item) => (
        <Badge
          type={
            item.status === "PENDING"
              ? "warning"
              : item.status === "REJECTED"
              ? "danger"
              : "success"
          }
          className="text-capitalize"
        >
          {item.status === "PENDING"
            ? "Pending"
            : item.status === "REJECTED"
            ? "Rejected"
            : "Approved"}
        </Badge>
      ),
    },
  ];

  useEffect(() => {
    fetchConcerns();
  }, [currentPage, limit]);

  const fetchConcerns = async () => {
    setIsLoading(true);
    try {
      const params = {
        page: currentPage - 1,
        size: limit,
      };

      const res = await axios.get(API_GET_RAISED_CONCERNS_BY_EMPLOYEE, {
        params,
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      const formattedData = res.data.content.map((item) => ({
        empName: item.empName,
        concernRequest: item.reason,
        concernDate: displayFormatDate(item.concernDate),
        punchIn: item.punchInTime ?? "NA",
        punchOut: item.punchOutTime ?? "NA",
        totalHours: item.totalHour ?? "NA",
        status: item.status ?? "-",
        _original: item,
      }));

      setTableData(formattedData);
      setTotalPages(res.data.totalPages);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (newPage) => setCurrentPage(newPage);
  const handleLimitChange = (e) => {
    setLimit(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <div className="wrapper-body">
      {isLoading && (
        <div className="overlay">
          <div className="mt-5">
            <TailSpin height="100" width="100" color="blue" visible={true} />
          </div>
        </div>
      )}

      <div className="page-heading mb-2">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <PageTitle title={title} description={description} />
      </div>
      <div className="d-flex col-md-12 justify-content-end mb-3 mt-0">
        <Link
          className="theme-button p-2 float-end"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdropRaiseConcern"
        >
          Raise Concern
        </Link>
      </div>
      {!isLoading && tableData.length > 0 ? (
        <>
          <SortableTable
            columns={columns}
            data={tableData}
            currentPage={currentPage}
            limit={limit}
          />
          <div className="row mt-3">
            <div className="col-md-3">
              <label htmlFor="itemsPerPage">Items per page </label>
              <select
                id="itemsPerPage"
                onChange={handleLimitChange}
                value={limit}
                className="border ms-3 w-25 p-2"
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={30}>30</option>
                <option value={40}>40</option>
              </select>
            </div>
            <div className="col-md-9">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </>
      ) : (
        <div className="text-center">
          {!isLoading && <NoRecordsAvailable />}
        </div>
      )}

      <div
        className="modal fade"
        id="staticBackdropRaiseConcern"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <RaiseConcern />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyConcerns;
